/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Lifetime_SessionsInputs */

const en_us2_progress_extra_lifetime_sessions = /** @type {(inputs: Progress_Extra_Lifetime_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`workouts`)
};

const pt_br2_progress_extra_lifetime_sessions = /** @type {(inputs: Progress_Extra_Lifetime_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`treinos`)
};

const es_419_progress_extra_lifetime_sessions = /** @type {(inputs: Progress_Extra_Lifetime_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entrenamientos`)
};

const pt_pt2_progress_extra_lifetime_sessions = /** @type {(inputs: Progress_Extra_Lifetime_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`treinos`)
};

const fr_fr2_progress_extra_lifetime_sessions = /** @type {(inputs: Progress_Extra_Lifetime_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séances`)
};

const de_de2_progress_extra_lifetime_sessions = /** @type {(inputs: Progress_Extra_Lifetime_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings`)
};

const it_it2_progress_extra_lifetime_sessions = /** @type {(inputs: Progress_Extra_Lifetime_SessionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`allenamenti`)
};

/**
* | output |
* | --- |
* | "workouts" |
*
* @param {Progress_Extra_Lifetime_SessionsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_lifetime_sessions = /** @type {((inputs?: Progress_Extra_Lifetime_SessionsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Lifetime_SessionsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_lifetime_sessions(inputs)
	if (locale === "es-419") return es_419_progress_extra_lifetime_sessions(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_lifetime_sessions(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_lifetime_sessions(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_lifetime_sessions(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_lifetime_sessions(inputs)
	return en_us2_progress_extra_lifetime_sessions(inputs)
});
export { progress_extra_lifetime_sessions as "progress-extra.lifetime_sessions" }